<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    class="programs-table"
  >
    <template v-slot:item="{ item }">
      <tr :class="{ 'programs-table__row--inactive': !item.active }">
        <td>{{ item.name }}</td>
        <td>{{ item.description }}</td>
        <td>
          <v-chip
            :color="item.active ? 'accent' : 'grey'"
            small
            @click="$emit('toggle-status', item)"
          >
            {{ item.active ? 'Active' : 'Inactive' }}
          </v-chip>
        </td>
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('edit', item)"
              >
                bhi-pencil
              </v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                @click="$emit('delete', item)"
              >
                bhi-trash
              </v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ProgramsTable',
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.programs-table {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &__row--inactive {
    background-color: rgba(0, 0, 0, 0.04);
  }
}
</style>
